import React from 'react'
import '../../Styles/serviceComponenetsStyles/devservices.css';
import computer from '../../Assets/CodeComputer.png'

export default function Devservices() {
  return (
    <div className='devservice'>
        <div className="devserviceContainer">
            <div className="serviceTop">
                <div className="leftTop">
                    <div className="serviceHeading">DEVELOPING SERVICES</div>
                    <div className="serviceText">
                        <div>We do all types of website works includes e-commerce</div>
                        <div>platforms, medical apps, static web apps, enterprise </div>
                        <div>applications, real time application etc....</div>
                    </div>
                </div>
                <div className="rightTop">
                    <div className="rightServiceImg">
                        <img src={computer} alt="comImg" />
                    </div>
                </div>
            </div>
            <div className="serviceBottom">
                <div className="contactButton">
                    <button>CONTACT US</button>
                </div>
            </div>
        </div>
    </div>
  )
}
